import Vue from 'vue'
import App from './App.vue'
import router from './router'

import {library} from '@fortawesome/fontawesome-svg-core/index.js'
import {
    faCog,
    faHome,
    faSignInAlt,
    faSignOutAlt,
    faSpinner,
    faSave,
    faUser,
    faArrowsAlt,
    faEdit,
    faTrash,
    faSync,
    faFilePdf,
    faInfoCircle,
    faPlusCircle,
    faCopy,
    faPowerOff,
    faCircle,
    faLock,
    faSearch,
    faExclamationTriangle
} from '@fortawesome/free-solid-svg-icons'
import {FontAwesomeIcon} from '@fortawesome/vue-fontawesome'

library.add(faCog, faHome, faSignInAlt, faSignOutAlt, faSpinner, faSave, faUser, faArrowsAlt, faEdit, faTrash, faSync, faFilePdf, faInfoCircle, faPlusCircle, faCopy, faPowerOff, faCircle, faLock, faSearch, faExclamationTriangle);

Vue.component('fa', FontAwesomeIcon);

import axios from 'axios'
import VueAxios from 'vue-axios'

/* Logout if the XHR msg says something wrong with the hash */
axios.interceptors.response.use(function (response) {
    if ( response.data.msgType === 'logout' ) {
        router.push('/login');
        router.app.authenticated = false;
    }
    return response;
}, function (error) {
    return Promise.reject(error);
});

Vue.use(VueAxios, axios);

import VModal from 'vue-js-modal'
Vue.use(VModal, { dialog: true, dynamic: true });

import Notify from 'vue-notification'
Vue.use(Notify);

import VueMoment from 'vue-moment'
Vue.use(VueMoment);

import VueSimpleMarkdown from 'vue-simple-markdown'
import 'vue-simple-markdown/dist/vue-simple-markdown.css'
Vue.use(VueSimpleMarkdown)

Vue.config.productionTip = false;

Vue.filter('toCurrency', function (value) {
    if (typeof value !== "number") {
        return value;
    }
    var formatter = new Intl.NumberFormat('de-DE', {
        style: 'currency',
        currency: 'EUR',
        minimumFractionDigits: 2
    });
    return formatter.format(value);
});

/* Vue helper functions */
Vue.mixin({
    methods: {
        qs(data) {
            let ret = [];
            for (let d in data)
                ret.push(encodeURIComponent(d) + '=' + encodeURIComponent(data[d]));
            return ret.join('&');
        },
        pad(num, size) {
            let s = num + "";
            while (s.length < size) s = "0" + s;
            return s;
        },
        dynamicSort(property) {
            let sortOrder = 1;
            if ( property[0] === "-" ) {
                sortOrder = -1;
                property = property.substr(1);
            }
            return function (a,b) {
                /* next line works with strings and numbers,
                 * and you may want to customize it to your needs
                 */
                let aCompare = a[property],
                    bCompare = b[property];

                // if we have date in property we must order with other function
                if ( property.search(/date/gi) ) {
                    let regex = /(\d+)\.(\d+)\.(\d+)\s(\d+):(\d+)/;

                    aCompare = a[property].replace(regex, '$3$2$1$4$5'),
                    bCompare = b[property].replace(regex, '$3$2$1$4$5');
                }

                let result = (aCompare < bCompare) ? -1 : (aCompare > bCompare) ? 1 : 0;

                return result * sortOrder;
            }
        }
    }
});

// Login Guard function no acces to any route if not logged in
router.beforeEach((to, from, next) => {
    if (!router.app.authenticated && typeof router.app.authenticated !== 'undefined' && to.path !== '/login') {
        next('/login');
    } else {
        next();
    }
});

new Vue({
    router,
    render: h => h(App),
    data: {
        authenticated: false
    }
}).$mount('#app');